<template>
  <div ref="componentRef" :class="$style.component">
    <img
      v-if="imageUrl"
      ref="imageRef"
      :class="$style.image"
      :src="imageUrl"
      :alt="label"
      :style="{
        ...size ? {
          width: pixels(size[0]),
          height: pixels(size[1])
        } : {}
      }"
    />
    <div
      v-if="label"
      ref="labelRef"
      :class="[
        $style.label,
        labelType === 'heading' ? $style.heading : $style.body,
        $style[`size-${labelSize}`]
      ]"
    >
      {{label}}
    </div>
  </div>
</template>

<script>
import {ref} from '@vue/composition-api'

import useZoom from '@/composition/useZoom'

export default {
  props: {
    imageUrl: {type: String, required: false},
    label: {type: String, required: false},
    size: {type: Array, required: false},
    labelType: {type: String, required: false, default: 'body'},
    labelSize: {type: String, required: false, default: 'm'},
  },
  setup () {
    const imageRef = ref()
    const labelRef = ref()

    useZoom(imageRef, 1.0, true)
    useZoom(labelRef, 1.0, true)

    return {
      imageRef,
      labelRef,
      pixels (val) {
        if (typeof val === 'number') return val + 'px'
        return val
      },
    }
  },
}
</script>

<style module lang="scss">
.component {
  text-align: center;
}

.image {
  max-width: unset;
}

.label {
  margin-top: variables.$spacing-12;
  white-space: pre-wrap;

  &.heading {
    @include mixins.m-heading-size;

    &.size-xl {
      @include mixins.xl-heading-size;
    }
    &.size-l {
      @include mixins.l-heading-size;
    }
    &.size-s {
      @include mixins.s-heading-size;
    }
    &.size-xs {
      @include mixins.xs-heading-size;
    }
  }
  &.body {
    @include mixins.m-body-size;

    &.size-xl {
      @include mixins.xl-body-size;
    }
    &.size-l {
      @include mixins.l-body-size;
    }
    &.size-s {
      @include mixins.s-body-size;
    }
    &.size-xs {
      @include mixins.xs-body-size;
    }
  }
}
</style>
